(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[257],{

/***/ 62622:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[[...route]]",
      function () {
        return __webpack_require__(10502);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Account; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var change_case__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14831);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _templates_account__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62282);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93183);
/* eslint-disable import/no-unresolved */ 






var isBrowser = "object" !== "undefined";
var __N_SSG = true;
function Account(param) {
    var initialSettings = param.settings;
    var ref, ref1;
    var liveSettings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useSettings)();
    var settings = liveSettings || initialSettings;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), AccountSubTemplate = ref2[0], setAccountSubTemplate = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), first = ref3[0], setFirst = ref3[1];
    // If account.menu has been set, we use the first item in the list as default subRoute
    var defaultAccountTemplateComp = "orders";
    var ref4 = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_3__.useCustomerAuth)({
        autoRedirect: true,
        defaultRoute: "/account/orders",
        id: "withAccount"
    }), customer = ref4.customer, authenticated = ref4.authenticated;
    /*
      Map an template/account/*.jsx component to an /account/subRoute
      Doing this in a useEffect is important so that these chunked out templates get dynamically loaded
    */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1;
        if (authenticated === undefined) return;
        var TemplateComponent = null;
        var TemplateComponentName;
        if (typeof _templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z !== "object" || !Object.keys(_templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).length) {
            return;
        }
        var subRoute = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.route) === null || ref1 === void 0 ? void 0 : ref1[0];
        if (subRoute) {
            TemplateComponentName = (0,change_case__WEBPACK_IMPORTED_MODULE_6__/* .paramCase */ .o)(subRoute);
            var haveTemplateForSubRoute = _templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[TemplateComponentName];
            if (haveTemplateForSubRoute) {
                // If we have an account template matching this subRoute we use the template;
                TemplateComponent = _templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[TemplateComponentName];
            } else {
                // The subRoute is not defined in the menu and there's no template for it. Display the default account template
                TemplateComponent = _templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[defaultAccountTemplateComp];
            }
        } else if (_templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[defaultAccountTemplateComp]) {
            // path is /accounts e.g no subRoute
            // We render the first menu item as default
            TemplateComponent = _templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z[defaultAccountTemplateComp];
        }
        var activeAccountTemplate = TemplateComponent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
            fallback: "Loading...",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TemplateComponent, {
                settings: settings,
                customer: customer
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            children: [
                "`$",
                TemplateComponentName,
                " account template not defined`"
            ]
        });
        setAccountSubTemplate(activeAccountTemplate);
    }, [
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.route) === null || ref1 === void 0 ? void 0 : ref1[0],
        authenticated,
        _templates_account__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        customer
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setFirst(false);
    }, []);
    if (!isBrowser) return null;
    if (first) {
        return null;
    }
    // render the correct account template based on the account/path
    return  true && customer && AccountSubTemplate ? AccountSubTemplate : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .AccountsAuthLoader */ .iT, {});
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [12,282,774,888,179], function() { return __webpack_exec__(62622); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);